import { tinyCfg } from './config';

$(document).ready(function () {

    var kbwApplication = (function () {

        var $window = $(window);

        let ajaxEndpoint = '/kbw/application/';

        var init = function () {
            addEventListeners();
            return;
        };

        var addEventListeners = function () {
            tinymce.init({
                ...{selector: '.js-explanation-editor-text'}, ...tinyCfg
            });

            $('.js-app-toggle-price').on('click', handleTogglePrice);
            $('.js-app-explain-price').on('click', handleEditExplanation);
            $('.js-save-explanation').on('click', handleSaveExplanation);
            $('.js-cancel-explanation').on('click', handleCancelExplanation);

            $('.js-set-rating').on('click', handleSetRating);
            $('.js-app-toggle-hidden').on('click', handleToggleHidden);

            // $('.js-explanation-editor--mppe .js-save-explanation').on('click', handleSaveMainpriceProposalExplanation);
            // $('.js-explanation-editor--mppe .js-cancel-explanation').on('click', handleCancelMainpriceProposalExplanation);


            // $('.js-app-toggle-mainpriceproposal').on('click', handleToggleMainpriceProposal);
            // $('.js-app-explain-mainpriceproposal').on('click', handleEditExplanation);
            // $('.js-explanation-editor--mppe .js-save-explanation').on('click', handleSaveMainpriceProposalExplanation);
            // $('.js-explanation-editor--mppe .js-cancel-explanation').on('click', handleCancelMainpriceProposalExplanation);
            //
            // $('.js-app-explain-specialpriceproposal').on('click', handleEditExplanation);
            // $('.js-explanation-editor--sppe .js-save-explanation').on('click', handleSaveSpecialpriceProposalExplanation);
            // $('.js-explanation-editor--sppe .js-cancel-explanation').on('click', handleCancelSpecialpriceProposalExplanation);
            //
            // $('.js-app-toggle-specialpriceproposal').on('click', handleToggleSpecialpriceProposal);

        }

        // Event Listeners

        var handleTogglePrice = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let aid = $target.data('aid');
            let price = $target.data('price');

            let url = ajaxEndpoint + 'tp';
            let data = {
                applicationId: aid,
                price: price
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, updatePrice);
        }

        var handleEditExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');

            if (!$container.hasClass('js-status-container--active')) {
                $container.addClass('js-status-container--active');
            }
        }

        var handleSaveExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let $form = $target.parents('.js-edit-form-explanation');
            let aid = $form.find('input[name="aid"]').val();
            let type = $form.find('input[name="type"]').val();
            let num = $form.find('input[name="num"]').val();
            let fn = $form.find('input[name="fn"]').val();

            let tceId = $form.find('textarea[name="explanation"]').attr('id');
            let text = tinymce.get(tceId).getContent();

            let url = ajaxEndpoint + 'save_exp';
            let data = {
                applicationId: aid,
                fn: fn,
                // type: type,
                // num: num,
                text: text
            }

            ajaxPost(url, data, $container, $target, updateExplanation);
        }

        var handleCancelExplanation = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let $form = $target.parents('.js-edit-form-explanation');
            let aid = $form.find('input[name="aid"]').val();
            // let type = $form.find('input[name="type"]').val();
            // let num = $form.find('input[name="num"]').val();
            let fn = $form.find('input[name="fn"]').val();

            let url = ajaxEndpoint + 'reset_exp';
            let data = {
                applicationId: aid,
                fn: fn
                // type: type,
                // num: num,
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, resetExplanation);
        }

        var handleSetRating = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let aid = $container.data('aid');
            let category = $container.data('category');
            let rating = $target.data('rating-value');

            console.log(rating);

            let url = ajaxEndpoint + 'sr';
            let data = {
                applicationId: aid,
                category: category,
                rating: rating
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, updateRating);
        }

        var handleToggleHidden = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-status-container');
            let aid = $target.data('aid');

            let url = ajaxEndpoint + 'th';
            let data = {
                applicationId: aid
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, updateHidden);
        }



        // Callbacks

        var resetExplanation = function($container, $target, data, returnData) {
            updateProposal($container, $target, returnData);
            let $form = $target.parents('.js-edit-form-explanation');
            $form.find('.js-explanation-editor-text').val(returnData['explanation']);

            let tceId = $form.find('textarea[name="explanation"]').attr('id');
            if (returnData['explanation']) {
                tinymce.get(tceId).setContent(returnData['explanation']);
            }
            $container.removeClass('js-status-container--active');
        }

        var updateExplanation = function ($container, $target, data, returnData) {
            updateProposal($container, $target, returnData);
            $container.removeClass('js-status-container--active');
        }

        var updatePrice = function ($container, $target, data, returnData) {
            updateProposal($container, $target, returnData);
        }

        var updateProposal = function ($container, $target, data) {
            let $explanationButton = $container.find('.js-app-explain-price');
            let $toggleButton = $container.find('.js-app-toggle-price');
            let $statusSymbol = $container.find('.js-app-status-price');

            $toggleButton.removeClass('button-ok');
            $statusSymbol.removeClass('circle-text--selected');
            $explanationButton.removeClass('button-ok')
            $explanationButton.removeClass('button-alert');

            if (data['button'] === 'active') {
                $toggleButton.addClass('button-ok');
                $statusSymbol.addClass('circle-text--selected');
                if (data['hasExplanation']) {
                    console.log('set');
                    $explanationButton.addClass('button-ok');
                } else {
                    $explanationButton.addClass('button-alert');
                }
            }
        }

        var updateRating = function ($container, $target, data, returnData) {
            let $explanationButton = $container.find('.js-app-explain-price');
            let $ratingButtons = $container.find('.js-set-rating');
            let $sumRatingsManager = $('.js-sum-ratings');

            $ratingButtons.removeClass('button-selected');

            $ratingButtons.each(function() {
                if ($(this).data('rating-value') == returnData['value']) {
                    $(this).addClass('button-selected');
                }
            });

            $explanationButton.removeClass('button-ok').removeClass('button-alert');

            if (returnData['value'] !== '-1') {
                if (returnData['hasExplanation']) {
                    $explanationButton.addClass('button-ok');
                } else {
                    $explanationButton.addClass('button-alert');
                }
            }

            let sumRatingsManagerLabel = (returnData['sumRatings'] == '-1') ? 'nicht nicht (vollständig) bewertet' : returnData['sumRatings'];
            $sumRatingsManager.html(sumRatingsManagerLabel);

        }

        var updateHidden = function ($container, $target, data, returnData) {
            let $explanationButton = $container.find('.js-app-explain-price');

            $explanationButton.removeClass('button-ok')
            $explanationButton.removeClass('button-alert');

            if (returnData['hidden']) {
                $('.js-app-container').addClass('app-hidden');
                $target.addClass('hidden');

                if (returnData['hasExplanation']) {
                    $explanationButton.addClass('button-ok');
                } else {
                    $explanationButton.addClass('button-alert');
                }
            } else {
                $('.js-app-container').removeClass('app-hidden');
                $target.removeClass('hidden');
            }
        }

        // Helpers

        var ajaxPost = function (url, data, $container, $target, successCallback) {
            $.ajax({
                method: "POST",
                url: url,
                data: data,
                dataType: "json"

            }).done(function (returnData) {
                console.log(returnData);
                // if (returnData['success']) {
                //     console.log(returnData['numDocs']);
                // }

                if (returnData['success'] === '1') {
                    successCallback($container, $target, data, returnData);
                } else {
                    alert(returnData['errMessage'])
                }

            }).fail(function (jqXHR, textStatus) {
                console.log(textStatus);
            });
        }

        return {
            init: init
        }

    })();

    kbwApplication.init();

});



